const names = [
  [
    [''],
    [' Mieczysław, Mieszko, Wilhelm'],
    ['Grzegorz, Makary, Izydor'],
    ['Danuta, Arleta, Genowefa'],
    ['Angelika, Eugeniusz, Tytus'],
    ['Hanna, Edward, Szymon'],
    ['Kacper, Melchior, Baltazar'],
    ['Lucjan, Julian, Teodor'],
    ['Seweryn, Teofil'],
    ['Marcjanna, Marcelina, Antoni'],
    ['Danuta, Jan, Wilhelm'],
    ['Honorata, Matylda, Feliks'],
    ['Arkadiusz, Benedykt, Czesława'],
    ['Weronika, Bogumiła, Izydor'],
    ['Feliks, Hilary, Ordon'],
    ['Paweł, Izydor, Aleksander'],
    ['Marceli, Włodzimierz, Bernard'],
    ['Marian, Jan, Antoni'],
    ['Piotr, Małgorzata'],
    ['Marta, Henryk, Mariusz'],
    ['Fabian, Sebastian'],
    ['Agnieszka, Inez, Jarosław'],
    ['Anastazy, Wincenty, Wiktor'],
    ['Maria, Ildefons, Rajmund'],
    ['Felicja, Rafał, Tymoteusz'],
    ['Tatiana, Paweł, Miłosz'],
    ['Paulina, Wanda, Tytus'],
    ['Angela, Jan, Przybysław'],
    ['Walery, Radomir, Karol'],
    ['Franciszek, Zdzisław, Zenon'],
    ['Martyna, Maciej, Marcin'],
    ['Marcelina, Ludwik, Jan']
  ],
  [
    [''],
    ['Brigida, Iga, Ignacy'],
    ['Maria, Mirosław, Joanna'],
    ['Błażej, Hipolit, Oskar'],
    ['Weronika, Mariusz, Andrzej'],
    ['Adelajda, Agata, Izydor'],
    ['Dorota, Bohdan, Ksenia'],
    ['Romuald, Ryszard, Teodor'],
    ['Piotr, Jan, Hieronim'],
    ['Apolonia, Eryka, Cyryl'],
    ['Elwira, Jacek, Scholastyka'],
    ['Maria, Lucjan, Łazarz'],
    ['Damian, Nora, Modest'],
    ['Katarzyna, Grzegorz, Julian'],
    ['Walenty, Liliana, Zenon'],
    ['Jowita, Faustyna, Józef'],
    ['Danuta, Juliana, Daniel'],
    ['Zbigniew, Julian, Łukasz'],
    ['Konstancja, Maksym, Bernadeta'],
    ['Arnold, Konrad, Marceli'],
    ['Leon, Ludmiła, Eustachy'],
    ['Eleonora, Feliks, Kiejstus'],
    ['Marta, Małgorzata, Piotr'],
    ['Romana, Izabela, Damian'],
    ['Maciej, Bogusz, Modest'],
    ['Wiktor, Cezary, Zygfryd'],
    ['Bogumił, Aleksandra, Mirosława'],
    ['Anastazja, Wiktor, Gabriel'],
    ['Makary, Prokop, Hilary'],
    ['Lutosław, Roman, Teofil']
  ],
  [
    [''],
    ['Antonina, Antoni, Albin'],
    ['Halszka, Helena, Radosław'],
    ['Kunegunda, Maryna, Tycjan'],
    ['Łucja, Kazimierz, Eugeniusz'],
    ['Adrian, Fryderyk, Oliwia'],
    ['Róża, Wiktor, Jordan'],
    ['Paweł, Tomasz, Felicyta'],
    ['Beata, Stefan, Wincenty'],
    ['Franciszka, Katarzyna, Dominik'],
    ['Aleksander, Cyprian, Marceli'],
    ['Konstanty, Lutosław, Benedykt'],
    ['Alojzy, Bernard, Grzegorz'],
    ['Bożena, Krystyna, Ernest'],
    ['Leon, Matylda, Michał'],
    ['Ludwika, Klemens, Longin'],
    ['Izabela, Hilary, Oktawia'],
    ['Gertruda, Patryk, Zbigniew'],
    ['Anzelm, Cyryl, Edward'],
    ['Józef, Bogdan, Marek'],
    ['Aleksandra, Klaudia, Anatol'],
    ['Lubomir, Benedykt, Mikołaj'],
    ['Bogusław, Katarzyna, Oktawian'],
    ['Pelagia, Feliks, Zbysław'],
    ['Gabriel, Marek, Gabor'],
    ['Maria, Ireneusz'],
    ['Teodor, Emanuela, Larysa'],
    ['Lidia, Ernest, Jan'],
    ['Aniela, Sykstus, Joanna'],
    ['Wiktoryna, Cyryl, Eustachy'],
    ['Amelia, Leonard, Dobromir'],
    ['Balbina, Beniamin, Gwidon']
  ],
  [
    [''],

    ['Grażyna, Zbigniew, Teodor'],
    ['Maria, Franciszek, Urban'],
    ['Renata, Jakub, Ryszard'],
    ['Wacław, Izydor, Benedykt'],
    ['Irena, Wincenty, Julianna'],
    ['Katarzyna, Celestyna, Wilhelm'],
    ['Donata, Herman, Rufin'],
    ['Julia, Dionizy, January'],
    ['Maria, Marceli, Dymitr'],
    ['Małgorzata, Michał, Makary'],
    ['Filip, Leon, Marek'],
    ['Juliusz, Zenon, Wiktor'],
    ['Ida, Hermenegilda, Przemysław'],
    ['Julianna, Justyna, Walerian'],
    ['Olimpia, Anastazja, Bazyli'],
    ['Julia, Erwina, Benedykt'],
    ['Klara, Robert, Rudolf'],
    ['Apoloniusz, Bogusława, Bogusław'],
    ['Adolf, Leon, Tymon'],
    ['Agnieszka, Teodor, Czesław'],
    ['Anzelm, Bartosz, Feliks'],
    ['Kaja, Leon, Łukasz'],
    ['Jerzy, Wojciech'],
    ['Aleks, Grzegorz, Aleksander'],
    ['Marek, Jarosław, Wasyl'],
    ['Maria, Marcelina, Marzena'],
    ['Felicja, Teofil, Zyta'],
    ['Waleria, Ludwik, Paweł'],
    ['Piotr, Robert, Bogusław'],
    ['Marian, Katarzyna, Jakub']
  ],
  [
    [''],

    ['Józef, Jeremiasz, Filip'],
    ['Anatol, Zygmunt, Anastazy'],
    ['Maria, Nina, Aleksander'],
    ['Florian, Malwina, Monika'],
    ['Irena, Waldemar, Iryda'],
    ['Judyta, Jan, Jurand'],
    ['Ludmiła, Gizela, Benedykt'],
    ['Stanisław, Eryk, Liza'],
    ['Grzegorz, Katarzyna, Karolina'],
    ['Antonina, Izydor, Antoni'],
    ['Mira, Franciszek, Ignacy'],
    ['Joanna, Dominik, Pankracy'],
    ['Gloria, Robert, Serwacy'],
    ['Maciej, Bonifacy, Dobiesław'],
    ['Zofia, Jan, Izydor'],
    ['Andrzej, Małgorzata'],
    ['Weronika, Sławomir, Brunon'],
    ['Alicja, Feliks, Eryk'],
    ['Mikołaj, Piotr, Urban'],
    ['Aleksander, Bernardyn, Bazyli'],
    ['Tymoteusz, Wiktor, Kryspin'],
    ['Julia, Wiesława, Helena'],
    ['Iwona, Michał, Dezyriusz'],
    ['Joanna, Zuzanna, Milena'],
    ['Grzegorz, Urban, Magda'],
    ['Filip, Paulina, Marianna'],
    ['Juliusz, Magdalena, Jan'],
    ['Augustyn, Jaromir, Wilhelm'],
    ['Magdalena, Teodozja, Maria'],
    ['Joanna, Feliks, Ferdynand'],
    ['Aniela, Petronela, Kamila']
  ],
  [
    [''],

    ['Hortencja, Jakub, Konrad'],
    ['Marianna, Marzena, Erazm'],
    ['Leszek, Anatola, Tamara'],
    ['Helga, Karol, Franciszek'],
    ['Kira, Bonifacy, Waleria'],
    ['Dominika, Laura, Norbert'],
    ['Jarosław, Robert, Wiesław'],
    ['Ada, Maksymilian, Seweryn'],
    ['Anna, Pelagia, Felicjan'],
    ['Bogumił, Małgorzata, Edgar'],
    ['Barnaba, Feliks, Benedykt'],
    ['Janina, Jan, Onufry'],
    ['Antoni, Lucjan, Gracja'],
    ['Bazyli, Eliza, Justyna'],
    ['Jolanta, Wiola, Wit'],
    ['Alina, Aneta, Justyna'],
    ['Albert, Laura, Adolf'],
    ['Elżbieta, Paula, Marek'],
    ['Gerwazy, Protazy, Julianna'],
    ['Bogna, Florentyna, Rafał'],
    ['Alicja, Marta, Alojz'],
    ['Paulina, Jan, Tomasz'],
    ['Wanda, Józef, Albin'],
    ['Danuta, Emilia, Jan'],
    ['Dorota, Łucja, Wilhelm'],
    ['Paulina, Jan, Paweł'],
    ['Cyryl, Maryla, Władysław'],
    ['Florentyna, Leon, Ireneusz'],
    ['Benita, Piotr, Paweł'],
    ['Emilia, Lucyna, Arnold']
  ],
  [
    [''],
    ['Halina, Marian, Klarysa'],
    ['Jagoda, Urban, Otton'],
    ['Anatol, Jacek, Tomasz'],
    ['Elżbieta, Malwina, Teodor'],
    ['Karolina, Antoni, Filomena'],
    ['Łucja, Dominika, Teresa'],
    ['Cyryl, Metody, Estera'],
    ['Elżbieta, Adrian, Edgar'],
    ['Weronika, Hieronim, Zenon'],
    ['Amelia, Filip, Witalis'],
    ['Cyprian, Olga, Benedykt'],
    ['Jan, Wera, Brunon'],
    ['Małgorzata, Ernest, Henryk'],
    ['Stella, Bonawentura, Marcelin'],
    ['Henryk, Włodzimierz, Brunon'],
    ['Maria, Stefan, Eustachy'],
    ['Aneta, Bogdan, Aleksy'],
    ['Kamil, Robert, Szymon'],
    ['Alfred, Wincenty, Włodzisław'],
    ['Czesław, Hieronim, Fryderyk'],
    ['Andrzej, Wiktor, Daniel'],
    ['Maria, Magdalena, Wawrzyniec'],
    ['Bogna, Brygida, Apolinary'],
    ['Kinga, Krystyna, Olga'],
    ['Jakub, Krzysztof, Walentyna'],
    ['Anna, Grażyna, Mirosława'],
    ['Julia, Natalia, Aureliusz'],
    ['Wiktor, Innocenty, Aida'],
    ['Marta, Olaf, Flora'],
    ['Ludmiła, Julita, Piotr'],
    ['Helena, Ignacy, Lubomir']
  ],
  [
    [''],

    ['Nadia, Justyna, Piotr'],
    ['Karina, Gustaw, Stefan'],
    ['Lidia, Augustyn, Nikodem'],
    ['Dominika, Jan, Protazy'],
    ['Oswald, Emil, Maria'],
    ['Sława, Jakub, Stefan'],
    ['Dorota, Konrad, Kajetan'],
    ['Iza, Cyprian, Dominik'],
    ['Klara, Roman, Romuald'],
    ['Borys, Bogdan, Wawrzyniec'],
    ['Luiza, Zuzanna, Włodzimierz'],
    ['Klara, Lech, Julian'],
    ['Diana, Hipolit, Maksym'],
    ['Alfred, Maksymilian, Euzebiusz'],
    ['Maria, Napoleon, Stefan'],
    ['Nora, Joachim, Roch'],
    ['Anita, Julianna, Jacek'],
    ['Helena, Ilona, Bogusław'],
    ['Konstancja, Emilia, Julian'],
    ['Sabina, Sobiesław, Bernard'],
    ['Joanna, Kazimiera, Franciszek'],
    ['Maria, Cezary, Tymoteusz'],
    ['Róża, Apolinary, Filip'],
    ['Bartłomiej, Jerzy, Bartosz'],
    ['Luiza, Patrycja, Ludwik'],
    ['Maria, Sandra, Ireneusz'],
    ['Monika, Cezary, Józef'],
    ['Patrycja, Erazm, Augustyn'],
    ['Sabina, Beata, Jan'],
    ['Róża, Szczęsny, Benon'],
    ['Izabela, Rajmund, Bohdan']
  ],
  [
    [''],
    ['Bronisława, Bronisz, Idzi'],
    ['Iza, Stefan, Julian'],
    ['Izabela, Szymon, Joachim'],
    ['Ida, Liliana, Roch'],
    ['Dorota, Wawrzyniec, Teodor'],
    ['Beata, Zachariusz, Eugeniusz'],
    ['Regina, Marek, Ryszard'],
    ['Maria, Nestor, Radosław'],
    ['Aldona, Piotr, Sergiusz'],
    ['Irma, Mikołaj, Łukasz'],
    ['Jacek, Feliks, Prot'],
    ['Amadeusz, Gwidon, Sylwin'],
    ['Eugenia, Jan, Apolinary'],
    ['Roksana, Bernard, Cyprian'],
    ['Albin, Nikodem, Roland'],
    ['Edyta, Kamil, Korneliusz'],
    ['Justyna, Narcyz, Franciszek'],
    ['Irena, Stanisław, Józef'],
    ['Konstancja, January'],
    ['Renata, Filipina, Eustachy'],
    ['Hipolit, Mateusz, Daria'],
    ['Tomasz, Maurycy'],
    ['Tekla, Bogusław'],
    ['Dora, Gerard, Teodor'],
    ['Aurelia, Władysław, Kamil'],
    ['Justyna, Łucja, Cyprian'],
    ['Damian, Wincenty, Kosma'],
    ['Marek, Wacław'],
    ['Michalina, Michał, Rafał'],
    ['Wera, Zofia, Honoriusz']
  ],
  [
    [''],
    ['Danuta, Igor, Remigiusz'],
    ['Sława, Dionizy, Teofil'],
    ['Teresa, Gerard, Bogumił'],
    ['Rozalia, Franciszek, Konrad'],
    ['Igor, Placyd, Apolinary'],
    ['Petra, Fryderyka, Artur'],
    ['Mirella, Marek, Sergiusz'],
    ['Brygida, Pelagia, Marcin'],
    ['Ludwik, Arnold, Bogdan'],
    ['Paulina, Daniel, Franciszek'],
    ['Aldona, Emil, Marian'],
    ['Serafina, Maksymilian, Witold'],
    ['Edwarda, Mikołaja, Teofila'],
    ['Liwii, Bernarda, Kaliksta'],
    ['Jadwigi, Teresy, Brunona'],
    ['Florentyny, Ambrożego, Gawła'],
    ['Lucyny, Małgorzaty, Wiktora'],
    ['Juliana, łukasza, Bogumiła'],
    ['Piotra, Michała, Ziemowita'],
    ['Ireny, Kleopatry, Jana'],
    ['Urszuli, Celiny, Hilarego'],
    ['Halki, Filipa, Przybysława'],
    ['Marleny, Edwarda, Seweryna'],
    ['Marty, Marcina, Rafała'],
    ['Ingi, Darii, Sambora'],
    ['Lucyny, Lucjana, Łucjana'],
    ['Iwony, Sabiny, Wincentego'],
    ['Judyty, Szymona, Tadeusza'],
    ['Wioletty, Serafina, Felicjana'],
    ['Zenobii, Edmunda, Przemysława'],
    ['Łukasza, Urbana, Augusta']
  ],
  [
    [''],
    ['Wszystkich, Świętych'],
    ['Bydar, Tobiasz, Bohdan'],
    ['Sylwia, Hubert, Marcin'],
    ['Olgierd, Karol'],
    ['Elżbieta, Zachariasz, Sławomir'],
    ['Feliks, Leonard, Ziemowit'],
    ['Karina, Ernest, Rudolf'],
    ['Wiktoria, Seweryn, Wiktoriusz'],
    ['Genowefa, Teodor, Ursyn'],
    ['Natalia, Leon, Andrzej'],
    ['Bartłomiej, Marcin'],
    ['Renata, Witold, Konrad'],
    ['Arkadia, Mikołaj, Stanisław'],
    ['Laura, Emil, Wawrzyniec'],
    ['Amelia, Albert, Leopold'],
    ['Maria, Edmund, Marek'],
    ['Waleria, Salomea, Grzegorz'],
    ['Aniela, Klaudyna, Roman'],
    ['Elżbieta, Seweryn, Paweł'],
    ['Edyta, Edmund, Anatol'],
    ['Albert, Janusz, Konrad'],
    ['Cecylia, Jonatan, Stefan'],
    ['Adela, Felicyta, Klemens'],
    ['Flora, Jan, Roman'],
    ['Katarzyna, Erazm, Klemens'],
    ['Konrad, Leonard, Sylwester'],
    ['Ksenia, Walerian, Franciszek'],
    ['Jakub, Lesław, Zdzisław'],
    ['Błażej, Walter, Fryderyk'],
    ['Justyna, Andrzej, Konstanty']
  ],
  [
    [''],
    ['Natalia, Blanka, Eligiusz'],
    ['Balbina, Paulina, Bibiana'],
    ['Franciszek, Hilary, Ksawery'],
    ['Barbara, Bernard, Krystian'],
    ['Krystyna, Sabina, Norbert'],
    ['Mikołaj, Emilian, Leontyna'],
    ['Agata, Ambroży, Marcin'],
    ['Maria, Wirginia, Wirgiliusz'],
    ['Aneta, Leokadia, Wiesław'],
    ['Julia, Judyta, Daniel'],
    ['Waldemar, Damazy'],
    ['Joanna, Aleksandra, Dagmara'],
    ['Łucja, Otylia, Eugeniusz'],
    ['Alfred, Izydor'],
    ['Nina, Celina, Walerian'],
    ['Albina, Zdzisław'],
    ['Olimpia, Łukasz, Jolanta'],
    ['Laura, Bogusław, Gracjan'],
    ['Dariusz, Urban, Gabriela'],
    ['Bogumiła, Dominik'],
    ['Jan, Honorata, Tomasz'],
    ['Franciszka, Bożena, Zenon'],
    ['Dagna, Wiktoria, Sławomir'],
    ['Adam, Ewa'],
    ['Eugenia, Piotr'],
    ['Dionizy, Szczepan'],
    ['Żaneta, Jan, Maksym'],
    ['Emma, Antoni, Teofila'],
    ['Dawid, Dominik, Tomasz'],
    ['Irmina, Eugeniusz'],
    ['Sylwester, Melania']
  ]
];

export { names };
export default { names };
